"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ContractVariable = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _VariableType = require("../VariableType");
var _ContractValueTypeHandler = require("../../type/ContractValueTypeHandler");
class ContractVariable extends _VariableType.ContractVariableType {
  constructor(api) {
    super();
    (0, _defineProperty2.default)(this, "settings", ContractVariable.settings);
    (0, _defineProperty2.default)(this, "type", "contract");
    (0, _defineProperty2.default)(this, "label", "Smart Contract");
    (0, _defineProperty2.default)(this, "description", "Load a smart contract into a variable.");
    this.api = api;
  }
  dependencies(params, resolver) {
    let address = resolver.resolveString(params.address);
    let chain = resolver.resolveString(params.chain);
    return {
      address,
      chain
    };
  }
  getValue(ref, deps, batcher) {
    if (!deps) {
      return null;
    }
    let {
      address,
      chain
    } = deps;
    if (!address || !chain) {
      ref.value = null;
      return;
    }
    return (0, _VariableType.handleValuePromise)(ref, this.api.getContract({
      address,
      chainId: chain
    }).then(data => new _ContractValueTypeHandler.VarsContract(data)));
  }
}
exports.ContractVariable = ContractVariable;
(0, _defineProperty2.default)(ContractVariable, "settings", {
  address: {
    type: "var",
    variableType: "value",
    description: "Address for the smart contract."
  },
  chain: {
    title: "Chain/Network",
    type: "var",
    variableType: "value",
    description: "Chain or network the contract is on."
  }
});
//# sourceMappingURL=ContractVariable.js.map